import Control from "../1. Core/Control";
import {PageMode, Trainer, TrainerStat} from "../10. Battle/types";
import TabControl from "../1. Core/Controls/TabControl/TabControl";
import NP from "../1. Core/NP";
import AthletesList from "../2. Athletes/AthletesList";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import {calculateAgeFromString} from "../10. Battle/Util";
import {loadFile} from "../1. Core/ScriptLoader";
import {ServerAPI} from "../1. Core/ServerAPI";
import Dialog from "../1. Core/Controls/Dialog/Dialog";


export default class TrainerPanel extends Control {
	private _Trainer: Trainer;
	private _topAppBar: TopAppBar;
	private _tabs: TabControl;
	private athletesList: AthletesList;
	private _infoNode: HTMLElement;
	private _textNode: HTMLElement;
	private _statNode: HTMLElement;
	private stat: TrainerStat;
	private _textStat: HTMLElement;
	private _chartNode: HTMLElement;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}


	_initFields(settings: object)
	{
		this._Trainer = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._topAppBar = new TopAppBar({
			Class: 'athletes-list__top-app-bar top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: this._Trainer.FirstName + " " + this._Trainer.LastName,
			ParentNode: this._root,
			ShowBackButton: true,
			ShowSearchButton: false
		});


		this._tabs = new TabControl({
			ParentNode: this._root,
			Items: [{
				Content: NP.RM.getString('Info'),
				Value: 'Info'
			}, {
				Content: NP.RM.getString('MMA Athletes'),
				Value: 'Table'
			}],
			EvTabSelected: () =>
			{
				if (this._tabs.getValue() == "Table")
					this.showTable();
				else
					this.showInfo();
			}
		});


		this._infoNode = NP.createNode(this._root, 'trainer-info-node');
		this._textNode = NP.createNode(this._infoNode, 'trainer-resume');


		this._textNode.innerHTML = `
			<img class="trainer-dash-img" src="${this._Trainer.PhotoUrl}"/>
			<div class="trainer-text">
				<div>${this._Trainer.FirstName + " " + this._Trainer.LastName} </div>  
				<div>${NP.RM.getString('Age')}: ${calculateAgeFromString(this._Trainer.BirthDate)} </div> 
				<div>${this._Trainer.Region || ''}</div> 
				<div>${this._Trainer.Education || ''}</div> 
				<div>${this._Trainer.Club || ''}</div> 
				<div>${this._Trainer.About || ''}</div> 
				<div>${NP.RM.getString('Experience')}: ${calculateAgeFromString(this._Trainer.WorkStartDate)}</div> 
			</div>`;


		this._statNode = NP.createNode(this._infoNode);

		this._textStat = NP.createNode(this._statNode, 'trainer-stat-text');
		this._chartNode = NP.createNode(this._statNode);

		this.refreshStat();
	}

	async refreshStat()
	{


		if (!(<any>window).Highcharts)
			return loadFile('highcharts.js').then(() => this.isLive() && this.refreshStat());


		// this.stat = {
		// 	StudentCount: 13,
		// 	WorldChampions: 5,
		// 	EuroMedalist: 1,
		// 	WorldMedalist: 2,
		// 	RUMedalist: 3,
		//
		// 	SP: 4,
		// 	HMS: 5,
		// 	IMS: 6,
		// 	CIS: 7
		// } as TrainerStat

		this.stat = await ServerAPI.get<TrainerStat>(`/trainers/stat/${this._Trainer.Id}`)

		this.stat.WorldChampions = 1;
		this.stat.RUMedalist = 3;
		this.stat.EuroMedalist = 2;

		this._textStat.innerHTML = `
			<div>
				<div>${NP.RM.getString('StudentCount')}: ${this.stat.StudentCount}</div>  
				<div>${NP.RM.getString('WorldChampions')}: ${this.stat.WorldChampions}</div> 
				<div>${NP.RM.getString('EuroMedalist')}: ${this.stat.EuroMedalist}</div> 
				<div>${NP.RM.getString('RUMedalist')}: ${this.stat.RUMedalist}</div> 
			</div>`;


		let values = ['SP', 'HMS', 'IMS', 'CIS', 'Adult1', 'Adult2', 'Adult3', 'Youth1', 'Youth2', 'Youth3']
			 .filter(name => this.stat[name] > 0)
			 .map(name => ({
				 id: name,
				 name: NP.RM.getString(name),
				 y: this.stat[name]
			 }));

		let self = this;

		(window as any).Highcharts.chart(this._chartNode, {
			chart: {
				backgroundColor: 'transparent',
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie',
				width: 600,
				height: 400
			},
			exporting: {
				buttons: {
					contextButton: {
						enabled: false
					}
				}
			},
			credits: {
				enabled: false
			},
			title: {
				style: {
					display: 'none'
				}
			},
			tooltip: {
				enabled: false
			},
			plotOptions: {
				series: {
					point: {
						events: {
							click: function ()
							{
								self.onPointClick(this);
							}
						}
					}
				},
				backgroundColor: 'transparent',
				pie: {
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '13px'
						},
						format: '<b>{point.name}</b>: {point.y}'
					}
				}
			},
			series: [{
				name: 'WinType',
				colorByPoint: true,
				data: values
			}]
		});
	}

	onPointClick(point: any)
	{
		let cat = point.options.id;
		let list = new AthletesList({
			UseCity: true,
			Mode: PageMode.mmaathletes,
			DrillDownFilter: {
				TrainerId: this._Trainer.Id,
				SportCategory: cat
			}
		})

		let dlg = new Dialog({
			ShowHeader: true,
			Width: 900,
			Mode: 'FullHeight',
			Caption: NP.RM.getString(cat),
			Class: 'nopad',
			ContentAutoFit: true,
			Content: list
		});

		list.getTopAppBar().setIsVisible(false)
		list.refresh();
		dlg.show();
		dlg.getCancelButton().setIsVisible(false);
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	showTable()
	{
		NP.hideNode(this._infoNode)

		if (!this.athletesList)
		{
			this.athletesList = new AthletesList({
				ParentNode: this._root,
				Mode: PageMode.mmaathletes,
				UseCity: true,
				ShowCategory: true,
				DrillDownFilter: {
					TrainerId: this._Trainer.Id
				}
			});
			this.athletesList.getTopAppBar().setIsVisible(false)
		}
		else
			this.athletesList.show();

		this.athletesList.setWidth(this.getWidth());
		this.athletesList.setHeight(this.getHeight());

		this.athletesList.refresh();

	}

	showInfo()
	{
		this.athletesList.hide();
		NP.showNode(this._infoNode)
		this.refreshStat();
	}
}